export const GURU_NFT_CONTRACT_ADDRESS = "0x2223e1fDc19C17ca87C6C7389636fbF82ffCb856";
export const AURA_TOKEN_CONTRACT_ADDRESS = "0x7e593bd1D39920993C7A8289A341B932547EC264";
export const STAKING_PROXY_NFT_CONTRACT_ADDRESS = "0xA100178be100aC612Db6c9C181ddbfCfF113b2f7";

export const CURRENT_WALLET_ADDRESS = "0xdBE2C656bb17cC3B91BAC4f09B2449B3DDb9131c";

export const GURU_NFT_LEVELUP_DEADLINE_DAYS = 30;
export const CORE_SET_NFT_LEVELUP_DEADLINE_DAYS = 30;


// WEBPACK FOOTER //
// ./src/constants/realShrine.js